import {FC, useContext, useState} from 'react';
import {useResetRecoilState, useSetRecoilState} from 'recoil';

import Modal from '@mui/material/Modal/Modal';
import Box from '@mui/system/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/system/Stack';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Divider from '@mui/material/Divider';

import {CompanyService} from '../../../../api/services/company.service';

import {companiesQueryTrigger, selectedCompaniesState} from '../../../../store/company/atoms';
import {EventBusContext} from '../../../../providers/EventBus';

interface IDeleteCompanies {
  open: boolean;
  selectedIDs: string[];
  handleClose: () => void;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  width: 500,
  p: 2,
};

const DeleteCompanies: FC<IDeleteCompanies> = ({open, handleClose, selectedIDs}) => {
  const triggerCompaniesQuery = useSetRecoilState(companiesQueryTrigger);
  const resetSelected = useResetRecoilState(selectedCompaniesState);
  const [loading, setLoading] = useState(false);
  const {bus} = useContext(EventBusContext);

  const handleDelete = async () => {
    try {
      setLoading(true);

      await CompanyService.deleteAFew(selectedIDs);

      setTimeout(() => {
        setLoading(false);
        handleClose();
        resetSelected();
        triggerCompaniesQuery((v) => v + 1);
      }, 1500);
    } catch (err) {
      bus?.emit('error', [err]);

      setLoading(false);
    }
  };

  return (
    <Modal open={open}>
      <Box sx={style}>
        <Toolbar
          sx={{
            pl: {sm: 1},
            pr: {xs: 1, sm: 1},
          }}
        >
          <Typography sx={{flex: '1 1 100%'}} variant="h6" id="formTitle" component="div">
            Подтвердите удаление
          </Typography>
        </Toolbar>
        <Divider sx={{m: '10px 0'}} />
        <Stack direction="row" sx={{justifyContent: 'space-between'}}>
          <Button variant="contained" disabled={loading} onClick={handleClose}>
            Отменить
          </Button>
          <LoadingButton color="error" variant="outlined" onClick={handleDelete} loading={loading}>
            Удалить
          </LoadingButton>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DeleteCompanies;
